"use strict";
/*
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getSortableFields(obj) {
    return [
        ...obj.primitiveFields,
        ...obj.scalarFields,
        ...obj.enumFields,
        ...obj.temporalFields,
        ...obj.pointFields,
        ...obj.cypherFields.filter((field) => [
            "Boolean",
            "ID",
            "Int",
            "BigInt",
            "Float",
            "String",
            "DateTime",
            "LocalDateTime",
            "Time",
            "LocalTime",
            "Date",
            "Duration",
        ].includes(field.typeMeta.name)),
    ].filter((field) => !field.typeMeta.array);
}
exports.default = getSortableFields;
//# sourceMappingURL=get-sortable-fields.js.map